<template>
  <div>
    <div v-if="mode==='pc'">
      <web-condition></web-condition>
    </div>
    <div v-if="mode==='mobile'">
      <web-mobile></web-mobile>
    </div>
  </div>
</template>

<script>

import WebCondition from "@/components/pc/PCWeb";
import WebMobile from "@/components/mobile/mobileWeb";
import axios from 'axios'
axios.defaults.withCredentials = true;
export default {
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     console.log("from", from, from.name);
  //     console.log("to", to, to.name);
  //     if (from.name == "login" || from == "") {
  //       location.reload();
  //     }
  //   });
  // },
  data() {
    return {
      token: ''
    };
  },
  components: {
    WebCondition,
    WebMobile
  },
  sockets: {
    connect: function() {
      console.log('connect');
      var me = this
      var token = localStorage.getItem('jwt')
      console.log('token :>> ', token);
      this.token = token
      if (token) {
        this.$socket.emit('authenticate', { token })
      }
    },
    authenticated: function(data) {
      console.log('authenticated')
      this.$socket.emit('checkToken', this.token)
    },
    tokenChecked(data) {
      console.log('tokenChecked', data);
      if (data && data.code === 0) {
        this.$socket.emit("getUserInfo", data.data)
        // this.$router.push({ path: '/' })
      } else {
        localStorage.removeItem('jwt')
      }
    },
    unauthorized: function(error) {
      console.log('unauthorized :>> ', error );
      if (error.message === 'jwt expired') {
        // this.$router.push({ path: "/" });
      }
    },
  },
  computed: {
    mode() {
      return this.$store.state.mode;
    }
  },
  mounted() {
    
    
  },
  methods: {
 
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/web.vue